import { Search } from "@/components/ui/search";

export function Hero() {
  return (
    <section className="text-center space-y-6 py-12">
      <div className="max-w-3xl mx-auto space-y-4">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl">
          Books That Shape{" "}
          <span className="text-primary">Bitcoin Culture</span>
        </h1>
        <p className="text-xl text-muted-foreground">
          Discover the books that inspire and educate the Bitcoin community.
          Curated recommendations from prominent Bitcoiners.
        </p>
      </div>
      <div className="max-w-md mx-auto">
        <Search
          placeholder="Search books, authors, or Bitcoiners..."
          className="w-full"
        />
      </div>
    </section>
  );
}